import React, { useEffect, useState } from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { useApp } from "app/contexts/AppContext";
import "./registerSuccess.css";
import HERO_IMAGE_1 from "../../images/hero-image-1.svg";
import HERO_IMAGE_2 from "../../images/hero-image-2.svg";
import APP_ICON from "../../images/app-icon.png";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "./helperConstants";

const RegisterSuccess = () => {
  const {
    device: { isMobile },
  } = useApp();
  const navigate = useNavigate();
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const handleContinue = () => {
    navigate("/background-survey");
  };

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);

    // Preload images - simplified version
    const imagesToPreload = [HERO_IMAGE_1, HERO_IMAGE_2, APP_ICON];
    let loadedCount = 0;

    const handleImageLoad = () => {
      loadedCount++;
      if (loadedCount === imagesToPreload.length) {
        setImagesLoaded(true);
      }
    };

    const handleImageError = () => {
      loadedCount++;
      if (loadedCount === imagesToPreload.length) {
        setImagesLoaded(true); // Still show even if some images fail
      }
    };

    // Preload each image
    imagesToPreload.forEach((src) => {
      const img = new Image();
      img.onload = handleImageLoad;
      img.onerror = handleImageError;
      img.src = src;
    });

    // Fallback: show images after 2 seconds even if not all loaded
    const fallbackTimer = setTimeout(() => {
      setImagesLoaded(true);
    }, 2000);

    return () => clearTimeout(fallbackTimer);
  }, []);

  return (
    <Container className="register-success-container">
      <div className="w-100" style={{ maxWidth: "856px" }}>
        <div className="content-wrapper">
          <div className="app-preview-container">
            <img
              src={HERO_IMAGE_1}
              alt="Morph App Preview 1"
              className="app-preview-image hero-image-1"
              style={{
                opacity: imagesLoaded ? 1 : 0,
                transition: "opacity 0.3s ease-in-out",
              }}
            />
            <img
              src={HERO_IMAGE_2}
              alt="Morph App Preview 2"
              className="app-preview-image hero-image-2"
              style={{
                opacity: imagesLoaded ? 1 : 0,
                transition: "opacity 0.3s ease-in-out",
              }}
            />
          </div>

          <div className="app-download-content">
            <h1 className="page-title">Account Created!</h1>
            <p className="welcome-text">
              Welcome to Morph! Your account is ready.
            </p>
            <h3 className="app-title">Get Morph mobile app</h3>
            <p className="app-description text-center">
              Accelerate home inspections with
              <br />
              AI-powered assistance.
            </p>

            <div className="d-flex flex-column align-items-center mt-4">
              {isMobile ? (
                <Link
                  to={`${process.env.REACT_APP_URL}/app-download`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="app-icon-container"
                >
                  <img
                    src={APP_ICON}
                    alt="Morph App Icon"
                    style={{
                      opacity: imagesLoaded ? 1 : 0,
                      transition: "opacity 0.3s ease-in-out",
                    }}
                  />
                  <button className="text-button-link">Download Morph</button>
                </Link>
              ) : (
                <QRCodeSVG
                  value={`${process.env.REACT_APP_URL}/app-download`}
                  size={200}
                />
              )}
              {!isMobile && (
                <p className="scan-text mt-3">
                  Scan the QR code to download,
                  <br />
                  or visit{" "}
                  <a
                    href={APP_STORE_URL}
                    className="store-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    App Store
                  </a>{" "}
                  ·{" "}
                  <a
                    href={GOOGLE_PLAY_URL}
                    className="store-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Google Play
                  </a>
                </p>
              )}
            </div>
          </div>
        </div>
        <Button
          variant="primary"
          className="mt-5 primary-action-button continue-button"
          onClick={handleContinue}
        >
          Continue
        </Button>
      </div>
      <footer className="login-footer">
        <Link
          to="https://www.morph-technologies.com/terms-conditions"
          className="footer-link"
          target="_blank"
        >
          Terms and Conditions
        </Link>
        <span className="footer-separator">•</span>
        <Link
          to="https://www.morph-technologies.com/privacy-policy"
          className="footer-link"
          target="_blank"
        >
          Privacy Policy
        </Link>
      </footer>
    </Container>
  );
};

export default RegisterSuccess;
